module.exports = __webpack_public_path__ + "assets/img/bg.94405dd6.jpg";